import { environment } from '@environment/environment';
import { StoreAction } from './store-action.model';
import { DebugHelper } from '@shared/helpers/debug.helper';

export class StoreActionError extends StoreAction<string> {
  constructor(public override payload: string) {
    super();

    if (!environment.production) {
      DebugHelper.error(this.payload);
    }
  }
}
